'use client';

import React from 'react';
import { analytics } from '@/utils/analytics';

declare var window: any;

interface Props {
  title?: string;
  videoId: string;
}

/**
 * These styles will adjust to all viewports.  Do not adjust.
 */
const WistiaVideoEmbed = ({ title, videoId }: Props) => {
  if (typeof window !== 'undefined') {
    window._wq = window._wq || [];
    window._wq.push({
      id: videoId,
      onReady: (video) => {
        video.bind('play', () => {
          analytics?.track('Video Started', {
            videoId,
          });
        });
        video.bind('end', () => {
          analytics?.track('Video Completed', {
            videoId,
          });
        });
      },
    });
  }

  return (
    videoId && (
      <div className="relative pt-[56.25%]">
        <div className="wistia_responsive_wrapper absolute left-0 top-1/2 m-0 h-full w-full translate-y-[-50%]">
          <div
            className={`wistia_embed wistia_async_${videoId} videoFoam=true popover=false muted=false h-full w-full`}
          >
            &nbsp;
          </div>
        </div>
      </div>
    )
  );
};

export default WistiaVideoEmbed;
